import { render, staticRenderFns } from "./IcpDetail.vue?vue&type=template&id=6b6b5120"
import script from "./IcpDetail.vue?vue&type=script&lang=js"
export * from "./IcpDetail.vue?vue&type=script&lang=js"
import style0 from "./IcpDetail.vue?vue&type=style&index=0&id=6b6b5120&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports